export const PetAction = {
  FEED: 'walk',
  WITHDRAW: 'dead',
  DEFAULT: 'idle'
};
